import { HttpMethods, makeRequest } from '../helpers/http.helper';
import {
  MaterialTypeRequest,
  UpdateMaterialTypeRequest,
  MaterialTypeQueryParams,
} from '../types/recycling.type';

// Material Types
export const getMaterialTypes = (organizationId: string, params?: MaterialTypeQueryParams) => {
  return makeRequest({
    url: `/material_type/list/${organizationId}`,
    method: HttpMethods.GET,
    params: params || {},
  });
};

export const getMaterialType = (materialTypeId: string) => {
  return makeRequest({
    url: `/material_type/${materialTypeId}`,
    method: HttpMethods.GET,
  });
};

export const createMaterialType = (materialType: MaterialTypeRequest) => {
  return makeRequest({
    url: '/material_type',
    method: HttpMethods.POST,
    data: materialType,
  });
};

export const updateMaterialType = (materialTypeId: string, materialType: UpdateMaterialTypeRequest) => {
  return makeRequest({
    url: `/material_type/${materialTypeId}`,
    method: HttpMethods.PUT,
    data: materialType,
  });
};

export const deleteMaterialType = (materialTypeId: string) => {
  return makeRequest({
    url: `/material_type/${materialTypeId}`,
    method: HttpMethods.DELETE,
  });
}; 